export default __webpack_public_path__ + "static/media/question.23405aeb.svg";